import { AuthService } from 'app/services/auth.service';

export function localizationFactory(authService: AuthService) {
  return authService.localeData;
}
